<template>
  <router-link 
    :to="`/projects/${project.referencement}`" 
    class="project-card" 
    @mouseover="setHoverState(true)" 
    @mouseleave="setHoverState(false)"
  >
    <div class="project-card">
      <div class="image-container">
        <!-- Image fixe -->
        <img 
          :src="`/projects_assets/${project.image_card}`" 
          alt="Project Image" 
          class="menu-image"
        >
      </div>
      <div class="project-text">
        <h1 class="project-title">{{ project.title }}</h1>
        <h2 class="project-title-2">{{ project.title_2 }}, {{ project.date }}</h2>
      </div>
    </div>
  </router-link>

  <!-- Vidéo -->
  <transition name="fade">
    <!-- YouTube -->
    <iframe 
      v-if="isHovered && isYouTubeVideo" 
      :src="youtubeEmbedUrl" 
      frameborder="0" 
      allow="autoplay; fullscreen" 
      class="background-video"
    ></iframe>

    <!-- GIF -->
    <img 
      v-else-if="isHovered && isGif" 
      :src="`/projects_assets/${project.background_hover}`" 
      alt="Background GIF" 
      class="background-video"
    >

    <!-- MP4 -->
    <video 
      v-else-if="isHovered && isMp4" 
      autoplay loop muted class="background-video"
    >
      <source :src="`/projects_assets/${project.background_hover}`" type="video/mp4">
    </video>

    <!-- Image -->
    <img 
      v-else-if="isHovered && isImage" 
      :src="`/projects_assets/${project.background_hover}`" 
      alt="Background Image" 
      class="background-video"
    >

  </transition>
</template>
  
  <script>
  export default {
    name: 'ProjectCard',
    props: {
      project: Object
    },
  data() {
    return {
      isHovered: false
    };
  },
  computed: {
    isYouTubeVideo() {
      return this.project.background_hover?.includes("youtube.com") || 
             this.project.background_hover?.includes("youtu.be");
    },
    isGif() {
      return this.project.background_hover?.endsWith(".gif");
    },
    isMp4() {
      return this.project.background_hover?.endsWith(".mp4");
    },
    youtubeEmbedUrl() {
      if (!this.isYouTubeVideo) return "";
      const videoId = this.project.background_hover.split("v=")[1]?.split("&")[0] || 
                      this.project.background_hover.split("/").pop();
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}`;
    },
    isImage() {
      return this.project.background_hover?.endsWith(".jpg") || 
             this.project.background_hover?.endsWith(".png");
    }
  },
  methods: {
    setHoverState(state) {
      this.isHovered = state;
    }
  }
  };
  </script>
  
  <style scoped>

  h2 {
    color: black;
    text-shadow: none;
  }

.project-card {
  padding: 5px;
  text-align: left;
  position: relative;
  z-index: 2;
  transition: transform 1.1s ease, box-shadow 0.3s ease;
}

.project-card:hover {
  transform: scale(1.007);
  z-index: 5;
}


.project-card img, .menu-video {
  width: 100%;
}

.image-container {
  position: relative;
}

.menu-video {
  width: 100%;
  height: auto;
}

.background-video {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  z-index: 1;
  /* opacity: 0.7; */
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1.1s ease-in-out;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

a {
  display: block;
  margin-top: 10px;
  text-decoration: none;
  font-weight: bold;
}

.project-title {
  font-size: 18px;
  padding: 0;
}
.project-title-2 {
  font-size: 12px;
  padding: 0;
  
}

.project-text {
  background-color: white;
}

</style>
  